import React, {useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Navbar, Nav, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import HomeIcon from '@material-ui/icons/Home';
import GitHubIcon from '@material-ui/icons/GitHub';
import 'bootstrap/dist/css/bootstrap.min.css';

const useStyles = makeStyles(theme => ({
  text: {
    textDecoration: 'none !important',
    background: 'none',
    border: 'none',
    fontWeight: 600,
    paddingLeft: '14px',
    paddingRight: '14px',
    color: 'black',
    '&:hover': {
      color: "#FFC500",
      border: 'none'
    },

  },

})
)
const Header = () => {
  const classes = useStyles();
  // const [auth, setAuth] = useState(false)
  return (

    <Navbar collapseOnSelect expand="lg" bg="ligth" style={{ paddingLeft: 0 }}>
      <Nav.Link >
        <Link to='/'  >
          <Button variant='warning'>
            <HomeIcon />
          </Button>
        </Link>
      </Nav.Link>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link>
            <Link to='/portfolio' className={classes.text}>
              Portfolio
          </Link>
          </Nav.Link>
          <Nav.Link>
            <Link to='/projects' className={classes.text}>
              Projects
          </Link>
          </Nav.Link>
          <Nav.Link>
            <Link to='/contact' className={classes.text}>
              Contact
          </Link>
          </Nav.Link>
        </Nav>
        <Nav>
          <Nav.Link eventKey={2}>
            <button onClick={() => window.open("https://www.github.com/mednajjar", "_blank")} className={classes.text}>
              <GitHubIcon />
            </button>
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Header
